// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonMenuOperatingData_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 10L10 10V8L0 8V10ZM0 6L10 6V4L0 4V6ZM12 2L0 2V0H12V2ZM9.14216 14.9267L9.49993 16H10.4999L10.8577 14.9267C11.5993 14.7985 12.285 14.5069 12.8763 14.0903L13.8909 14.5976L14.598 13.8905L14.0906 12.8758C14.507 12.2846 14.7985 11.5992 14.9266 10.8578L15.9999 10.5V9.5L14.9266 9.14224C14.7983 8.40013 14.5064 7.71405 14.0894 7.1225L14.596 6.1093L13.8889 5.4022L12.8753 5.909C12.6024 5.7168 12.3093 5.55122 11.9999 5.41605V7.7639C12.6137 8.31322 12.9999 9.1115 12.9999 10C12.9999 11.6569 11.6568 13 9.99993 13C9.11143 13 8.31314 12.6138 7.76382 12H5.41597C5.55149 12.3102 5.71757 12.6039 5.91041 12.8775L5.40381 13.8907L6.11092 14.5978L7.12453 14.091C7.7156 14.5072 8.40093 14.7986 9.14216 14.9267Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonMenuOperatingData is a generated icon component.
 */
let IconCommonMenuOperatingData = IconCommonMenuOperatingData_1 = class IconCommonMenuOperatingData extends IconBaseElement {
    render() {
        return html `${IconCommonMenuOperatingData_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonMenuOperatingData.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconCommonMenuOperatingData = IconCommonMenuOperatingData_1 = __decorate([
    customElement('zui-icon-common-menu-operating-data')
], IconCommonMenuOperatingData);
export { IconCommonMenuOperatingData };
